import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing-toggle"
export default class extends Controller {
  static targets = [ "monthlyBtn", "annualBtn", "premiumPrice", "premiumPeriod", "annualNote", "tablePrice" ]

  connect() {
    this.showMonthly()
  }

  showMonthly() {
    this.monthlyBtnTarget.classList.add("pricing-toggle-btn--active")
    this.annualBtnTarget.classList.remove("pricing-toggle-btn--active")
    
    this.premiumPriceTargets.forEach(el => el.textContent = "₹999")
    this.premiumPeriodTargets.forEach(el => el.textContent = "/month")
    this.annualNoteTargets.forEach(el => el.style.visibility = "hidden")
    this.tablePriceTargets.forEach(el => el.textContent = "₹999/mo")
  }

  showAnnual() {
    this.annualBtnTarget.classList.add("pricing-toggle-btn--active")
    this.monthlyBtnTarget.classList.remove("pricing-toggle-btn--active")
    
    this.premiumPriceTargets.forEach(el => el.textContent = "₹833")
    this.premiumPeriodTargets.forEach(el => el.textContent = "/month")
    this.annualNoteTargets.forEach(el => el.style.visibility = "visible")
    this.tablePriceTargets.forEach(el => el.textContent = "₹833/mo")
  }
}
